export class TicketSiteTransformer {

  toClass(data = {}) {
    const site = {
      id: data.id,
      label: data.name,
      project_id: data.project_id

    }
    if (data.children && data.children.length) {
      site.children = data.children.map(child => new TicketSiteTransformer().toClass(child));
    }

    return site;
  }

}


// WEBPACK FOOTER //
// ./resources/js/tickets/components/TicketSitesTransformer.js